import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../components/PageShell";

const NotFound = () => (
  <PageShell testId="page-notfound">
    <section className="max-w-3xl mx-auto px-6 md:px-12 pt-16 pb-32 text-center">
      <div className="font-manrope text-[10px] tracking-[0.3em] uppercase text-[#A8D2FA] mb-4">
        404
      </div>
      <h1 className="font-fraunces text-5xl md:text-7xl font-light text-slate-900 dark:text-slate-100 leading-[1.05]">
        This frame doesn&apos;t exist.
      </h1>
      <p className="mt-6 font-manrope text-slate-600 dark:text-slate-300">
        The page you&apos;re looking for has been moved, renamed, or simply never
        existed.
      </p>
      <Link
        to="/"
        className="mt-10 inline-flex items-center rounded-full bg-slate-900 text-white dark:bg-white dark:text-slate-900 px-7 py-3.5 font-manrope text-sm hover:bg-slate-800 dark:hover:bg-slate-100 transition"
      >
        Back home
      </Link>
    </section>
  </PageShell>
);

export default NotFound;
